document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.nav-links');

  const closeMenu = () => {
    if (!toggle || !menu) return;
    menu.classList.remove('open');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Abrir menú');
    document.body.classList.remove('menu-open');
  };

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = !menu.classList.contains('open');
      menu.classList.toggle('open', open);
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      document.body.classList.toggle('menu-open', open);
    });

    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  const tabs = [...document.querySelectorAll('[data-filter]')];
  const cards = [...document.querySelectorAll('[data-product-card]')];
  const search = document.querySelector('[data-product-search]');
  const empty = document.querySelector('[data-empty-products]');
  let active = 'all';

  const normalize = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const filter = () => {
    const term = normalize(search?.value);
    let visible = 0;
    cards.forEach(card => {
      const matchesType = active === 'all' || card.dataset.type === active;
      const matchesTerm = !term || normalize(card.dataset.search).includes(term);
      const show = matchesType && matchesTerm;
      card.hidden = !show;
      if (show) visible++;
    });
    if (empty) empty.hidden = visible > 0;
  };

  tabs.forEach(tab => tab.addEventListener('click', () => {
    active = tab.dataset.filter;
    tabs.forEach(item => item.classList.toggle('active', item === tab));
    filter();
  }));
  search?.addEventListener('input', filter);

  const setActiveView = () => {
    const body = document.body;
    if (!body.classList.contains('template-index')) return;
    const hash = (window.location.hash || '').replace('#', '').split('?')[0];
    const allowed = ['nosotros', 'donde-estamos', 'contacto'];
    if (allowed.includes(hash)) {
      body.dataset.activeView = hash;
      requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    } else {
      delete body.dataset.activeView;
    }
  };

  setActiveView();
  window.addEventListener('hashchange', setActiveView);
});
